var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 19.29 12.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#fff;}.cls-4{fill:#d50a2e;}.cls-5{fill:#3055ae;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 19.29,
    height: 12.86
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Text_Generator"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m0,0h19.29v12.86H0V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m0,0h19.29v.989H0v-.989Zm0,1.978h19.29v.989H0v-.989Zm0,1.978h19.29v.989H0v-.989Zm0,1.978h19.29v.989H0v-.989Zm0,1.982h19.29v.989H0v-.989Zm0,1.978h19.29v.989H0v-.989Zm0,1.978h19.29v.989H0v-.989Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m0,0h9.645v6.922H0V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1.797,5.223l-.15-.481-.165.481h-.496l.402.29-.15.481.41-.297.399.297-.154-.481.41-.29h-.504Zm2.117,0l-.154-.481-.158.481h-.496l.402.29-.15.481.402-.297.406.297-.15-.481.402-.29h-.504Zm2.124,0l-.162-.481-.15.481h-.508l.414.29-.158.481.402-.297.414.297-.158-.481.402-.29h-.496Zm2.113,0l-.15-.481-.158.481h-.5l.406.29-.15.481.402-.297.406.297-.162-.481.414-.29h-.508ZM3.76,2.831l-.158.481h-.496l.402.297-.15.474.402-.293.406.293-.15-.474.402-.297h-.504l-.154-.481Zm-2.113,0l-.165.481h-.496l.402.297-.15.474.41-.293.399.293-.154-.474.41-.297h-.504l-.15-.481Zm4.23,0l-.15.481h-.508l.414.297-.158.474.402-.293.414.293-.158-.474.402-.297h-.496l-.162-.481Zm2.124,0l-.158.481h-.5l.406.297-.15.474.402-.293.406.293-.162-.474.414-.297h-.508l-.15-.481ZM1.647.929l-.165.474h-.496l.402.297-.15.478.41-.297.399.297-.154-.478.41-.297h-.504l-.15-.474Zm2.113,0l-.158.474h-.496l.402.297-.15.478.402-.297.406.297-.15-.478.402-.297h-.504l-.154-.474Zm2.117,0l-.15.474h-.508l.414.297-.158.478.402-.297.414.297-.158-.478.402-.297h-.496l-.162-.474Zm2.124,0l-.158.474h-.5l.406.297-.15.478.402-.297.406.297-.162-.478.414-.297h-.508l-.15-.474Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.d0bbca2f9e6e192634448907658b2bc2.svg";
export { ForwardRef as ReactComponent };